import Vue from 'vue'
import App from './App.vue'
// import '../node_modules/@imp/package/allComponent' // 引入编辑端项目组件

export default function createApp(context: any): any {
  return new Vue({
    render: h => h(App, { props: { globalData: context } }),
    // render: h => h(App)
  })
}

// new Vue({
//   render: h => h(App)
// }).$mount('#app')
